export function AnalyticsPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Analytics</h1>
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
        Analytics dashboard coming soon...
      </div>
    </div>
  );
}
